import { createFileRoute, redirect } from '@tanstack/react-router';
import { isWeaveTokenActive, isWeaveTokenBufferActive } from '@frontend/auth-helpers';
import { checkIsUserAuthenticated } from '../../utils/helpers';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    if (checkIsUserAuthenticated() || isWeaveTokenActive() || isWeaveTokenBufferActive()) {
      return redirect({
        to: '/dashboard',
      });
    } else {
      return redirect({
        to: '/sign-in',
      });
    }
  },
});
